var moment = require('moment')
var dateutils = require('./dateutils')

const state = {
  all: [],
  headers: ['show_details', 'show_campaign_claims', 'taxInvoice', 'customerAccount', 'orderDate', 'status', 'createdDate', 'createdBy', 'updatedDate', 'updatedBy'],
  currentPage: 1,
  rowsPerPage: 20,
  totalRows: 0,
  disablePaginationComponent: true,
  selectedTaxInvoice: '',
  detailAll: [],
  detailHeaders: ['lensDesign', 'lensIndex', 'orderType', 'quantity', 'netAmount', 'status', 'createdDate', 'createdBy', 'updatedDate', 'updatedBy'],
  claimDetails: {
    requested: [],
    pairing: []
  },
  claimDetailHeaders: [
    { key: 'campaignDocId', label: 'Campaign ID', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
    { key: 'paired', label: 'Paired?', sortable: true },
    { key: 'requestedTaxInvoice', label: 'Requested Invoice', sortable: true },
    { key: 'pairingTaxInvoice', label: 'Pairing Invoice', sortable: true },
    { key: 'claimSubtypesText', label: 'Quantity Used', sortable: true },
    { key: 'totalQuantityUsed', label: 'Total Lenses Used', sortable: true },
    { key: 'drawRecordsCount', label: 'Draw Count', sortable: true },
    { key: 'remainingDrawTimes', label: 'Draws Left', sortable: true },
    { key: 'createdDate', label: 'Created Date', sortable: true },
    { key: 'updatedDate', label: 'Updated Date', sortable: true }
  ],
  showLoadingAnimation: false,
  showLoadingError: false,
  loadingErrorMessage: '',
  showNoResult: false,
  disabledPagination: false,
  lastShown: {
    lastShownPage: 1,
    firstRowShown: '',
    lastRowShown: ''
  }
}

function formatClaimSubtypes (subtypes) {
  if (!Array.isArray(subtypes) || subtypes.length === 0) {
    return '-'
  }

  return subtypes.map(eachType => {
    let quantity = Number(eachType.claimQuantity || 0)
    return 'Subtype: ' + (eachType.docId || eachType.subTypeDocId || '-') + '\nLenses: ' + quantity
  }).join('\n\n')
}

function sumClaimSubtypes (subtypes) {
  if (!Array.isArray(subtypes)) {
    return 0
  }

  return subtypes.reduce(function (total, eachType) {
    return total + Number(eachType.claimQuantity || 0)
  }, 0)
}

function formatDateTime (value) {
  if (!value) {
    return ''
  }

  return moment(dateutils.toJsDate(value)).format('DD/MMM/YYYY hh:mm:ss a')
}

function buildClaimDetailRow (doc, direction) {
  let data = doc.data()
  let claimSubtypes = direction === 'pairing'
    ? (data.pairingClaimSubtypes || data.pairedClaimSubtypes || [])
    : (data.requestedClaimSubtypes || [])

  return {
    docId: doc.id,
    campaignDocId: data.campaignDocId || '',
    claimEmail: data.claimEmail || '',
    status: data.status || '',
    paired: data.paired === true ? 'Yes' : 'No',
    requestedTaxInvoice: data.requestedTaxInvoice || '',
    pairingTaxInvoice: data.pairingTaxInvoice || data.pairedTaxInvoice || '',
    claimSubtypesText: formatClaimSubtypes(claimSubtypes),
    totalQuantityUsed: sumClaimSubtypes(claimSubtypes),
    drawRecordsCount: Array.isArray(data.drawRecords) ? data.drawRecords.length : 0,
    remainingDrawTimes: data.remainingDrawTimes || 0,
    createdDate: formatDateTime(data.createdDate),
    updatedDate: formatDateTime(data.updatedDate)
  }
}

function pushUniqueClaimDetail (rows, row) {
  let found = rows.find(function (eachRow) {
    return eachRow.docId === row.docId
  })

  if (!found) {
    rows.push(row)
  }
}

const mutations = {
  updateFromOrderDate: function (state, dateString) {
    console.log('Updating from order date to: ' + dateString)
    let m = moment(dateString, 'DD/MM/YYYY')
    state.searchObject.orderDate = m
    console.log('Updated from order date to: ' + state.searchObject.orderDate)
  },
  updateToOrderDate: function (state, dateString) {
    console.log('Updating to order date to: ' + dateString)
    let m = moment(dateString, 'DD/MM/YYYY hh:mm:ss a')
    state.searchObject.orderDate = m
    console.log('Updated to order date to: ' + state.searchObject.orderDate)
  },
  setRowsPerPage: function (state, newRowsPerPage) {
    state.rowsPerPage = newRowsPerPage
  },
  changePageNumber: function (state, newCurrentPage) {
    state.currentPage = newCurrentPage
    // console.log('CHanged state page number to: ' + state.currentPage)
  },
  updateTotalRows: function (state, newTotalRows) {
    state.totalRows = newTotalRows
    // console.log('Mutated totalRows to: ' + state.totalRows)
  },
  updatedSelectedTaxInvoice: function (state, selectedTaxInvoice) {
    state.selectedTaxInvoice = selectedTaxInvoice
    // console.log('Updated selected tax invoice to: ' + selectedTaxInvoice)
  },
  selectTableRow: function (state, invoiceId) {
    for (let i = 0; i < state.all.length; i++) {
      if (state.all[i].invoiceId === invoiceId) {
        state.all[i]._rowVariant = 'info'
      } else {
        state.all[i]._rowVariant = ''
      }
    }
  },
  toggleShowLoadingAnimation: function (state, show) {
    state.showLoadingAnimation = show
  },
  toggleshowLoadingError: function (state, show) {
    state.showLoadingError = show
  },
  toggleShowNoResult: function (state, show) {
    state.showNoResult = show
  },
  setLoadingErrorMessage: function (state, message) {
    state.loadingErrorMessage = message
  },
  toggleDisabledPagination: function (state, show) {
    state.disabledPagination = show
  }
}

const getters = {
  getAll: function (state, getters, rootState) {
    return state.all
  },
  getHeaders: function (state, getters, rootState) {
    let extraHeaders = []
    for (let i = 0; i < state.headers.length; i++) {
      let eachHeader = state.headers[i]
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      })
    }
    return extraHeaders
  },
  getDetailHeaders: function (state, getters, rootState) {
    let extraHeaders = []
    for (let i = 0; i < state.detailHeaders.length; i++) {
      let eachHeader = state.detailHeaders[i]
      extraHeaders.push({
        key: eachHeader,
        sortable: true
      })
    }
    return extraHeaders
  },
  getClaimDetailHeaders: function (state, getters, rootState) {
    return state.claimDetailHeaders
  }
}

const actions = {
  generateInvoiceReport (context, payload) {
    context.state.all = []
    console.log('Generating invoice report...')
    let startTime = performance.now()
    let startM = moment('14/12/2018 00:00:00', 'DD/MM/YYYY HH:mm:ss')
    let endM = moment('28/02/2019 23:59:59', 'DD/MM/YYYY HH:mm:ss')
    let docQuery = context.rootState.firestoreDB.collection('invoices').where('orderDate', '>=', startM.toDate()).where('orderDate', '<=', endM.toDate())
    if (!docQuery) {
      return
    }
    docQuery.get().then(function (querySnapshot) {
      console.log('query result: ' + querySnapshot.size)
      let endTime = performance.now()
      console.log('Time spent: ' + (endTime - startTime) / 60000 + ' mins.')
    })
  },
  showAllInvoices (context, payload) {
    context.state.all = []
    // context.state.headers = []
    context.commit('toggleDisabledPagination', true)

    context.commit('toggleShowLoadingAnimation', true)
    context.commit('toggleshowLoadingError', false)
    context.commit('toggleShowNoResult', false)

    // count total rows
    context.rootState.realtimeDb.ref('invoices').once('value').then(function (snapshot) {
      if (snapshot.val()) {
        context.commit('updateTotalRows', Number(snapshot.val().rowCount))
      } else {
        let calculatedTotalRows = 0
        let firstQuery = context.rootState.firestoreDB.collection('imports')
        firstQuery.get().then(function (querySnapshot) {
          querySnapshot.forEach(function (doc) {
            calculatedTotalRows = calculatedTotalRows + Number(doc.data().importedNewInvoices) + Number(doc.data().importedUpdateInvoices)
            // console.log('calculatedTotalRows:' + calculatedTotalRows)
            context.commit('updateTotalRows', calculatedTotalRows)
          })
        })
      }
    })

    console.log('Last shown page:' + context.state.lastShown.lastShownPage)
    console.log('Rows per page: ' + context.state.rowsPerPage)
    console.log('Total pages:' + Math.ceil(context.state.totalRows / context.state.rowsPerPage))
    console.log('Last shown row:' + context.state.lastShown.lastRowShown)
    console.log('First shown row:' + context.state.lastShown.firstRowShown)

    // if is next page, we can re-use the lastRowShown
    // if is previous page, we use the opposite sorting, and re-use the firstRowShown
    // if jump to last page, we use opposite sorting, and re-calculate the limit from total rows
    let collectionName = 'invoices'
    let flippedSorting
    let docQuery
    let jumpedPage
    let jumpedLimit
    console.log('currentPage: ' + context.state.currentPage)
    if (context.state.currentPage === 1) {
      console.log('Show first page')
      docQuery = context.rootState.firestoreDB.collection(collectionName)
        .orderBy(payload.orderBys, 'desc')
        .limit(context.state.rowsPerPage)
    } else if (context.state.currentPage === Math.ceil(context.state.totalRows / context.state.rowsPerPage)) {
      console.log('Show last page')
      let limit = context.state.totalRows % context.state.rowsPerPage
      if (limit === 0) {
        limit = context.state.rowsPerPage
      }
      flippedSorting = true
      docQuery = context.rootState.firestoreDB.collection(collectionName)
        .orderBy(payload.orderBys, 'asc')
        .limit(limit)
    } else if (context.state.currentPage - context.state.lastShown.lastShownPage === 1) {
      console.log('Show next page')
      docQuery = context.rootState.firestoreDB.collection(collectionName)
        .orderBy(payload.orderBys, 'desc')
        .startAfter(context.state.lastShown.lastRowShown)
        .limit(context.state.rowsPerPage)
    } else if (context.state.currentPage - context.state.lastShown.lastShownPage === -1) {
      console.log('Show previous page')
      flippedSorting = true
      docQuery = context.rootState.firestoreDB.collection(collectionName)
        .orderBy(payload.orderBys, 'asc')
        .startAfter(context.state.lastShown.firstRowShown)
        .limit(context.state.rowsPerPage)
    } else if (context.state.currentPage > 1 && context.state.currentPage === context.state.lastShown.lastShownPage) {
      console.log('Re-Show not first page')
      docQuery = context.rootState.firestoreDB.collection(collectionName)
        .orderBy(payload.orderBys, 'desc')
        .startAt(context.state.lastShown.firstRowShown)
        .limit(context.state.rowsPerPage)
    } else {
      if (context.state.currentPage > context.state.lastShown.lastShownPage) {
        console.log('Jumped forward page')
        let limit = (context.state.currentPage - context.state.lastShown.lastShownPage) * context.state.rowsPerPage
        jumpedPage = true
        jumpedLimit = limit
        docQuery = context.rootState.firestoreDB.collection(collectionName)
          .orderBy(payload.orderBys, 'desc')
          .startAfter(context.state.lastShown.lastRowShown)
          .limit(limit)
      } else if (context.state.currentPage < context.state.lastShown.lastShownPage) {
        console.log('Jumped backward page')
        let limit = (context.state.lastShown.lastShownPage - context.state.currentPage) * context.state.rowsPerPage
        jumpedPage = true
        jumpedLimit = limit
        flippedSorting = true
        docQuery = context.rootState.firestoreDB.collection(collectionName)
          .orderBy(payload.orderBys, 'asc')
          .startAfter(context.state.lastShown.firstRowShown)
          .limit(limit)
      } else {
        console.error('Unsupported page navigation')
        context.commit('toggleDisabledPagination', false)
        return
      }
    }

    let flippedResult = []
    docQuery.get().then(function (querySnapshot) {
      let index = 0
      let jumpIndex = 0
      querySnapshot.forEach(function (doc) {
        if (jumpedPage && jumpIndex < (jumpedLimit - context.state.rowsPerPage)) {
          jumpIndex++
          return
        }
        if (index === 0) {
          context.state.lastShown.firstRowShown = doc
        }
        index++
        // console.log(subDoc.id + '=>' + subDoc.data())
        let documentData = doc.data()
        let invoiceObject = {}
        for (let eachProp in documentData) {
          let propName = eachProp
          // console.log('eachProp: ' + eachProp)
          if (propName === 'orderDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY')
          } else if (propName === 'createdDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else {
            invoiceObject[propName] = doc.data()[eachProp]
          }
        }
        invoiceObject['_showDetails'] = false
        invoiceObject.invoiceId = doc.id
        invoiceObject._rowVariant = ''
        if (flippedSorting === true) {
          flippedResult.push(invoiceObject)
        } else {
          context.state.all.push(invoiceObject)
        }
        context.state.lastShown.lastShownPage = context.state.currentPage
        context.state.lastShown.lastRowShown = doc
      })
      if (flippedSorting === true) {
        flippedResult.reverse()
        flippedResult.forEach(function (value) {
          context.state.all.push(value)
        })
        let tempHolder = context.state.lastShown.firstRowShown
        context.state.lastShown.firstRowShown = context.state.lastShown.lastRowShown
        context.state.lastShown.lastRowShown = tempHolder
      }
      context.commit('toggleShowLoadingAnimation', false)
      if (context.state.all.length === 0) {
        context.commit('toggleShowNoResult', true)
      }
      context.commit('toggleDisabledPagination', false)
    }).catch(function (err) {
      context.commit('toggleDisabledPagination', false)
      console.log('Error while fetching documents in invoice collection: ' + err)
      context.commit('toggleShowLoadingAnimation', false)

      context.commit('toggleshowLoadingError', true)
      context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
    })
  },
  fetchInvoiceDetails (context, payload) {
    // close the detail row if it was opened
    for (let i = 0; i < context.state.all.length; i++) {
      if (context.state.all[i].taxInvoice === payload.taxInvoice && context.state.all[i]._showDetails === true) {
        context.state.all[i]._showDetails = false
        return
      }
    }

    console.log('fetch invoice details for ' + payload.taxInvoice)
    context.state.detailAll = []
    let invoicesCollectionName = 'invoices'
    let invoiceSubtypesCollectionName = 'subtypes'
    let docQuery = context.rootState.firestoreDB.collection(invoicesCollectionName).doc(payload.taxInvoice).collection(invoiceSubtypesCollectionName)
    docQuery.get().then(function (querySnapshot) {
      querySnapshot.forEach(function (doc) {
        // console.log(doc.id + '=>' + doc.data())
        let documentData = doc.data()
        let invoiceSubTypesObject = {}
        invoiceSubTypesObject['__id'] = doc.id
        for (let eachProp in documentData) {
          let propName = eachProp
          // console.log('eachProp: ' + eachProp)
          if (propName === 'createdDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceSubTypesObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceSubTypesObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else {
            invoiceSubTypesObject[propName] = doc.data()[eachProp]
          }
        }
        context.state.detailAll.push(invoiceSubTypesObject)
        for (let i = 0; i < context.state.all.length; i++) {
          if (context.state.all[i].taxInvoice === payload.taxInvoice) {
            context.state.all[i].subTypes = context.state.detailAll
            // console.log('Added subtype')
            context.state.all[i]._showDetails = true
          }
        }
      })
    })
  },
  fetchInvoiceClaimDetails (context, payload) {
    if (!payload || !payload.taxInvoice) {
      return Promise.resolve()
    }

    context.state.claimDetails = {
      requested: [],
      pairing: []
    }

    let claimsCollectionName = 'claims'
    let requestedQuery = context.rootState.firestoreDB.collection(claimsCollectionName)
      .where('requestedTaxInvoice', '==', payload.taxInvoice)
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          context.state.claimDetails.requested.push(buildClaimDetailRow(doc, 'requested'))
        })
      })

    let pairingQuery = context.rootState.firestoreDB.collection(claimsCollectionName)
      .where('pairingTaxInvoice', '==', payload.taxInvoice)
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          pushUniqueClaimDetail(context.state.claimDetails.pairing, buildClaimDetailRow(doc, 'pairing'))
        })
      })

    let legacyPairedQuery = context.rootState.firestoreDB.collection(claimsCollectionName)
      .where('pairedTaxInvoice', '==', payload.taxInvoice)
      .get()
      .then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          pushUniqueClaimDetail(context.state.claimDetails.pairing, buildClaimDetailRow(doc, 'pairing'))
        })
      })

    return Promise.all([requestedQuery, pairingQuery, legacyPairedQuery])
  },
  searchInvoices (context, payload) {
    if (!payload.taxInvoice && !payload.customerAccount && !payload.status && !payload.orderDate) {
      return
    }
    context.commit('toggleShowLoadingAnimation', true)
    context.commit('toggleshowLoadingError', false)
    context.commit('toggleShowNoResult', false)
    context.state.all = []
    context.state.detailAll = []
    context.commit('updateTotalRows', 0)

    let invoicesCollectionName = 'invoices'
    let docQuery = context.rootState.firestoreDB.collection(invoicesCollectionName)
    console.log('filter by invoice: ' + payload.taxInvoice)
    if (payload.taxInvoice && payload.taxInvoice.length > 0) {
      docQuery = docQuery.where('taxInvoice', '==', payload.taxInvoice)
    }
    console.log('filter by customer acc: ' + payload.customerAccount)
    if (payload.customerAccount && payload.customerAccount.length > 0) {
      docQuery = docQuery.where('customerAccount', '==', payload.customerAccount)
    }
    console.log('filter by status: ' + payload.status)
    if (payload.status && payload.status.length > 0) {
      docQuery = docQuery.where('status', '==', payload.status)
    }
    console.log('filter by order date: ' + payload.orderDate)
    if (payload.orderDate && payload.orderDate.length > 0) {
      let startM = moment(payload.orderDate + ' 00:00:00', 'DD/MM/YYYY HH:mm:ss')
      let endM = moment(payload.orderDate + ' 23:59:59', 'DD/MM/YYYY HH:mm:ss')
      docQuery = docQuery.where('orderDate', '>=', startM.toDate()).where('orderDate', '<=', endM.toDate())
      // console.log('filter by order date: ' + m.toDate())
    }

    if (!docQuery) {
      return
    }

    docQuery = docQuery.limit(context.state.rowsPerPage)

    docQuery.get().then(function (querySnapshot) {
      context.commit('updateTotalRows', querySnapshot.size)
      querySnapshot.forEach(function (doc) {
        // console.log(doc.id + '=>' + doc.data())
        let documentData = doc.data()
        let invoiceObject = {}
        for (let eachProp in documentData) {
          let propName = eachProp
          // console.log('eachProp: ' + eachProp)
          if (propName === 'orderDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY')
          } else if (propName === 'createdDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else if (propName === 'updatedDate' && doc.data()[eachProp]) {
            let m = moment(dateutils.toJsDate(doc.data()[eachProp]))
            invoiceObject[propName] = m.format('DD/MMM/YYYY hh:mm:ss a')
          } else {
            invoiceObject[propName] = doc.data()[eachProp]
          }
        }
        invoiceObject['_showDetails'] = false
        invoiceObject.invoiceId = doc.id
        invoiceObject._rowVariant = ''
        context.state.all.push(invoiceObject)
      })
      context.commit('toggleShowLoadingAnimation', false)
      if (context.state.all.length === 0) {
        context.commit('toggleShowNoResult', true)
      }
    }).catch(function (err) {
      console.log('Error while fetching documents in invoice collection: ' + err)
      context.commit('toggleShowLoadingAnimation', false)

      context.commit('toggleshowLoadingError', true)
      context.commit('setLoadingErrorMessage', 'Error loading: ' + err + ' [Please try again]')
    })
  }
}

export default { namespaced: true, state, mutations, actions, getters }



// WEBPACK FOOTER //
// ./src/store/invoicesstoremodule.js